export let ConnectionTypes;
(function (ConnectionTypes) {
  ConnectionTypes["STANDALONE_CALLING_APP"] = "STANDALONE_CALLING_APP";
  ConnectionTypes["EXTERNAL"] = "EXTERNAL";
})(ConnectionTypes || (ConnectionTypes = {}));